module.exports = __webpack_public_path__ + "static/img/avatar.493688e.png";


//////////////////
// WEBPACK FOOTER
// ./static/pawnProducts/avatar.png
// module id = CII/
// module chunks = 1